import React from "react";
import { func, object, string } from "prop-types";

SearchBar.propTypes = {
  value: string.isRequired,
  placeholder: string,
  handleChange: func.isRequired,
  styles: object
};

SearchBar.defaultProps = {
  placeholder: "Search",
  value: "",
  styles: {}
}

function SearchBar(props) {
  return (
    <input
      type="text"
      placeholder={props.placeholder}
      className="searchbar"
      style={props.styles}
      value={props.value}
      onChange={props.handleChange}
    />
  );
}

export { SearchBar };



// WEBPACK FOOTER //
// ./src/common/SearchBar.js